// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom CSS for the Dropzone */
.dropzone {
    border: 2px dashed #ddd;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
    background-color: #fafafa;
  }
  
  .dropzone:hover {
    background-color: #f1f1f1;
  }
  
  .dropzone p {
    color: #666;
    font-size: 14px;
  }
  
  .dropzone img {
    max-width: 150px;
    max-height: 150px;
    border-radius: 50%;
    object-fit: cover;
  }
  `, "",{"version":3,"sources":["webpack://./src/dropZone.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB","sourcesContent":["/* Custom CSS for the Dropzone */\n.dropzone {\n    border: 2px dashed #ddd;\n    padding: 20px;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 5px;\n    background-color: #fafafa;\n  }\n  \n  .dropzone:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .dropzone p {\n    color: #666;\n    font-size: 14px;\n  }\n  \n  .dropzone img {\n    max-width: 150px;\n    max-height: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
